import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'config';

const configService = {
  rowData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  getData: () => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
    });
  },

  testConnection: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/test-connection`,
      data,
    });
  },
};
export default configService;
